<template>
    <div class="page">
        <div class="page-ele">
            <Page show-total show-sizer :page-size-opts="size_opts" :total="total"
                  :current="paging.page"
                  :page-size="paging.size" @on-change="handlePageNoChange"
                  @on-page-size-change="handlePageSizeChange"></Page>
        </div>
    </div>
</template>

<script>
    export default {
        name: "page-model",
        props: {
            paging: {
                type: Object,
                default: () => {
                    return {
                        page: 1,
                        size: 10,
                    }
                }
            },
            total: {
                type: Number,
                default: 0
            },
            size_opts: {
                type: Array,
                default:() => {
                    return [5,10,20,30,50,100]
                }
            }
        },
        methods: {
            handlePageNoChange(pageNo) {
                this.$emit('page-change', pageNo, this.paging.size);
            },
            handlePageSizeChange(pageSize) {
                this.$emit('page-change', 1, pageSize);
            }

        }
    }
</script>

<style scoped lang="less">
    .page {
        margin: 10px;
        overflow: hidden;

        &-ele {
            float: right;
        }
    }

</style>
